import { useContext, useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./Button";
import { GrFormEdit } from "react-icons/gr";
import { OTPService } from "../../services/Authentication/OTPService";
import { DataProvider } from "../../store/ContextProvider";
import { OTPServiced } from "../../services/Authentication/OTPServiced";

export const OTPController = ({ email, setOtp, otp, isOpen, onClose, setIsOpen, purpose, setConfirm, Setmessage, setSignUP }) => {
    const { BeURL } = useContext(DataProvider); 

    const otpRefs = useRef([])
    const [second, setSecond] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [resetKey, setResetKey] = useState(0);
      

    


    // useEffect(() => {
    //     let totalSeconds = 60; // 1 min
    //     setMinutes(Math.floor(totalSeconds / 60));
    //     setSecond(totalSeconds % 60);

    //     const timer = setInterval(() => {
    //         totalSeconds -= 1;
    //         setMinutes(Math.floor(totalSeconds / 60));
    //         setSecond(totalSeconds % 60);

    //         if (totalSeconds <= 0) {
    //             clearInterval(timer);
    //         }
    //     }, 1000);

    //     return () => clearInterval(timer);
    // });

    useEffect(() => {
        if (isOpen) { 
            let totalSeconds = 90;
            setMinutes(Math.floor(totalSeconds / 60));
            setSecond(totalSeconds % 60);
            const timer = setInterval(() => {
                totalSeconds -= 1;
                setMinutes(Math.floor(totalSeconds / 60));
                setSecond(totalSeconds % 60);
                if (totalSeconds <= 0) {
                    clearInterval(timer);
                }
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [isOpen, resetKey]); // ✅ Run only when popup open

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return; // Only digits

        const newOtp = [...otp];
        newOtp[index] = value; // Replace current value
        setOtp(newOtp);

        if (value && index < 5) {
            otpRefs.current[index + 1]?.focus(); // Move forward
        }
    };

    const handleOtpKeyDown = (index, e) => {
        const newOtp = [...otp];

        switch (e.key) {
            case "Backspace":
                e.preventDefault();
                if (newOtp[index]) {
                    newOtp[index] = "";
                    setOtp(newOtp);
                } else if (index > 0) {
                    otpRefs.current[index - 1]?.focus();
                    newOtp[index - 1] = "";
                    setOtp(newOtp);
                }
                break;

            case "ArrowLeft":
                e.preventDefault();
                if (index > 0) otpRefs.current[index - 1]?.focus();
                break;

            case "ArrowRight":
                e.preventDefault();
                if (index < 5) otpRefs.current[index + 1]?.focus();
                break;

            default:
                break;
        }
    };

    const handleOtpPaste = (e) => {
        const pasted = e.clipboardData.getData("text").slice(0, 6).split("");
        const newOtp = [...otp];
        for (let i = 0; i < 6; i++) {
            newOtp[i] = pasted[i] || "";
        }
        setOtp(newOtp);
        otpRefs.current[Math.min(pasted.length, 5)]?.focus();
    };

    const handleResendOTP = () => {
        OTPService({ email, BeURL, setConfirm, setIsOpen, Setmessage, purpose });
        setResetKey(prev => prev + 1);
    };

    const handleVerifyOtp = (onClose) => {
        OTPServiced({ BeURL, email, otp, setOtp, onClose, purpose, setSignUP });
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 flex justify-center items-center bg-black/40 backdrop-blur-sm z-50 px-1 sm:px-3 md:px-6"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <motion.div
                        className="bg-[#ecf1ff] rounded-2xl shadow-2xl p-3 sm:p-8 w-full md:w-[500px] space-y-2"
                        initial={{ scale: 0.8, opacity: 0, y: -40 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.8, opacity: 0, y: -40 }}
                        transition={{ type: "spring", stiffness: 100, damping: 20, duration: 0.6 }}
                    >
                        <div className="text-center space-y-2">
                            <h2 className="text-xl font-bold">Verify Email OTP</h2>
                            <p className="text-gray-600">
                                We&apos;ve sent a 6-digit OTP to your registered Email
                            </p>
                        </div>
                        <div className="text-center  flex items-center justify-center gap-2" onClick={() => onClose(false)} >
                            <p>{email}</p>
                            <p className="text-[30px] text-[#2C25C4]"><GrFormEdit /></p>
                        </div>
                        <form className="mt-4 space-y-4" onSubmit={(e) => e.preventDefault()}>
                            {/* OTP Inputs */}
                            <div className="flex flex-col space-y-1">
                                <label className="font-medium text-gray-700">
                                    Enter OTP <span className="text-red-500">*</span>
                                </label>
                                <div>
                                    <div className="flex gap-2 sm:gap-3 justify-between">
                                        {Array.from({ length: 6 }).map((_, i) => (
                                            <input
                                                key={i}
                                                ref={(el) => (otpRefs.current[i] = el)}
                                                maxLength="1"
                                                type="text"
                                                value={otp[i]}
                                                onChange={(e) => handleOtpChange(i, e.target.value)}
                                                onKeyDown={(e) => handleOtpKeyDown(i, e)}
                                                onPaste={handleOtpPaste}
                                                className={`w-10 h-10 sm:w-12 sm:h-12 border rounded-lg text-center text-lg focus:outline-none focus:ring-2 focus:ring-blue-400`}
                                            />
                                        ))}
                                    </div>
                                    {/* <div className="flex px-3 relative bottom-2 justify-between">
                                        {Array.from({ length: 6 }).map((_, i) => (
                                            <div key={i} className="h-[2px] w-6 sm:w-7 bg-gray-400"></div>
                                        ))}
                                    </div> */}
                                    <h2 className="text-sm sm:text-base text-end font-medium text-gray-700">
                                        {minutes}:{second < 10 ? `0${second}` : second}
                                    </h2>
                                </div>
                            </div>

                            {/* Button */}
                            <div className="flex justify-end gap-5">
                                {second === 0 && (
                                <Button
                                        disabled={minutes > 0 || second > 0}
                                        className={`${second === 0
                                            ? "border"
                                            : "border-[#2C25C4] border"
                                            } w-full sm:w-60 bg-white h-12 text-[#2C25C4]`}
                                        onClick={handleResendOTP}
                                        children={"Resend OTP"}
                                    />
                                )}
                                <Button
                                    type="button"
                                    disabled={otp.filter((d) => d !== "").length < 6}
                                    className={`${otp.filter((d) => d !== "").length < 6
                                        ? "bg-gray-400"
                                        : "bg-[#2C25C4]"
                                        } w-full sm:w-60 h-12 text-white`}
                                    onClick={() => handleVerifyOtp(onClose)}
                                    children={"Verify & complete"}
                                />
                            </div>
                        </form>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
